import React from 'react';
import Sidebar from './sidebar'


export default function Aside(){
    return (
        <Sidebar />
    )
}
